import {
  describeNonConformities,
  type QualityLine,
} from '@obraplan/core/domain/planning/daily-report-quality';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
  TableWrapper,
} from '@/components/ui/table';
import { ReportSection } from './DailyReportSection';

/**
 * "Verificação de qualidade" — a seção derivada do RDO (Fase 19, fatia 4).
 *
 * Não tem campo e não tem botão de gravar: tudo aqui sai das verificações feitas na
 * medição do dia (ADR-128). Corrigir uma resposta é responder de novo em Conferência →
 * Medição e fotos — que é onde ela foi afirmada.
 */
export function DailyReportQuality({
  quality,
  editable,
}: {
  quality: readonly QualityLine[];
  editable: boolean;
}) {
  return (
    <ReportSection
      title="Verificação de qualidade"
      description="O serviço declarado em cada frente e a checklist respondida na medição. A não conformidade sai com o número dela — é ele que o FORM.30 acompanha."
      editable={editable}
      isSaving={false}
    >
      {quality.length === 0 ? (
        <p className="text-sm text-(--color-content-muted)">
          Nenhuma verificação de qualidade neste dia. Ela é feita em Conferência → Medição e fotos,
          ao gravar a quantidade de uma frente com serviço cadastrado.
        </p>
      ) : (
        <TableWrapper>
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Frente</TableHead>
                <TableHead>Serviço</TableHead>
                <TableHead>Checklist</TableHead>
                <TableHead className="text-right">Aprovados</TableHead>
                <TableHead className="text-right">Reprovados</TableHead>
                <TableHead>Não conformidades</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {quality.map((linha) => (
                <TableRow key={`${linha.activityId}|${linha.serviceName}`}>
                  <TableCell>{linha.description}</TableCell>
                  <TableCell>{linha.serviceName}</TableCell>
                  <TableCell className="text-(--color-content-muted)">
                    {linha.checklistName ?? 'sem checklist'}
                  </TableCell>
                  <TableCell className="tabular text-right">
                    {linha.checklistName === undefined ? '—' : linha.approved}
                  </TableCell>
                  <TableCell className="tabular text-right">
                    {linha.checklistName === undefined ? '—' : linha.rejected}
                  </TableCell>
                  <TableCell>{describeNonConformities(linha) || '—'}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableWrapper>
      )}
    </ReportSection>
  );
}
